import _ from 'lodash';

import { API_URL_NAMES } from '../../constants/endpoints';

/**
 * Constructs a URL by replacing placeholders in the base URL with provided identifiers.
 *
 * @param {keyof typeof API_URL_NAMES} urlName - The key representing the base URL from API_URL_NAMES.
 * @param {(string | number)[]} urlIds - An array of identifiers to replace placeholders in the URL.
 * @returns {string} - The constructed URL with placeholders replaced by identifiers.
 */
export function buildUrl(
  urlName: keyof typeof API_URL_NAMES,
  urlIds: (string | number)[] = []
) {
  let url: string = API_URL_NAMES[urlName];

  if (urlIds.length > 0) {
    const parts = url.split('{0}');
    const pairs = _.zip(parts, urlIds);
    url = _.flatMap(pairs, (pair: string[]) => pair.join('')).join('');
  }

  return url;
}

/**
 * Converts a data object into FormData format, suitable for HTTP requests.
 *
 * @param {Record<string, any>} data - An object containing key-value pairs to be converted.
 * @returns {FormData} - The FormData object containing the key-value pairs.
 */
export function buildFormData(data: Record<string, any>) {
  const formData = new FormData();
  for (const key in data) {
    if (data[key] !== undefined) {
      formData.append(key, data[key]);
    }
  }

  return formData;
}
